import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

// Store actions/selectors
import { setStatus } from 'store/Admin/OrderDisplay';
import { setOrderId, setOrderType } from 'store/Admin/Analyser';

// Hooks & utils
import { ORDERSTATUS } from 'utils/Constants';

// UI Components
import OrdersTable from 'components/shared/OrdersTable';

import './order.css';
import { adminClientOrderListSelector } from 'store/AdminClient/OrderList';
import {
  fetchadminCLientOrderDisplay,
  fetchadminCLientOrderLineDisplay,
  fetchAdminClientTextOrderDisplay,
} from 'store/AdminClient/OrderDisplay/features';
import ProjectTable from 'components/shared/ProjectTable';

export default function NonAttributedProject() {
  const dispatch = useDispatch();

  const { t } = useTranslation();
  const { nonAttributedOrders, isLoading, isError } = useSelector(
      adminClientOrderListSelector
  );

  useEffect(() => {
    window.dispatchEvent(new Event('locationchange'));
  }, []);

  return (
      <ProjectTable
          title={t('Projets non attribuées')}
          orderStatus={ORDERSTATUS.NONATTRIBUTED}
          orders={nonAttributedOrders}
          isLoading={isLoading}
          isError={isError}
          fetchDisplayData={(id, orderType) => {
            dispatch(setStatus(ORDERSTATUS.NONATTRIBUTED));
            dispatch(setOrderId(id));
            dispatch(setOrderType(orderType));
            dispatch(fetchadminCLientOrderDisplay(id));
            dispatch(fetchAdminClientTextOrderDisplay(id));
            dispatch(fetchadminCLientOrderLineDisplay(id));
          }}
          onRowClickRedirectPath="/AdminClient/DetailsProject"
      />
  );
}
